const WORDS = [
  "Esperienza",
  "Tecnologia",
  "Passione",
  "Precisione",
  "Sicurezza",
  "Affidabilità",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="marquee"
      className="flex select-none overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-6"
      aria-hidden="true"
    >
      <div className="animate-marquee flex shrink-0 items-center whitespace-nowrap">
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-[9vw] font-bold uppercase leading-none tracking-tight text-stroke md:text-[6vw]">
              {w}
            </span>
            <span className="mx-8 text-[#FF2A2A] md:mx-12">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
